import { Button, Col, Row, Space } from "antd";
import { Form, Formik } from "formik";

import { Input, Select } from "components/form";
import styles from "../styles/EmployeeFilter.module.css";
import useStatusFlagOption from "components/elements/Select/StatusDropdown";
import { useTranslation } from "react-i18next";

const WelfareFilter = ({
  initialValues = {},
  shiftOptions = [],
  titleNameOptions = [],
  employeeTypeOptions = [],
  modifiedPositionOptions = [],
  organizationUnderOptions = [],
  welfareList = [],
  welfareOption = [],
  welfareTypeOptions = [],
  welfareSubTypeOptions = [],
  shiftDropDown = [],
  onCancel = () => { },
  onSubmit = () => { },
  onSearch = () => { },
}) => {
  const { t } = useTranslation();
  const { modifiedStatus = [] } = useStatusFlagOption()
  // const [loading, setLoading] = useState(false);
  // const [imageUrl, setImageUrl] = useState(null);
  // const [optionType, setOptionType] = useState(null);

  const statusOption = [
    {
      value: "All",
      name: "All"
    },
    {
      value: "Active",
      name: "Active"
    },
    {
      value: "Inactive",
      name: "Inactive"
    },
    {
      value: "Delete",
      name: "Delete"
    }
  ]
  return (

    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        onSubmit({
          ...values,
          type: "Welfare"
        });
      }}

    // validationSchema={schema}
    >
      {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
        return (
          <Form>
            <Row gutter={[24, 16]} className={styles.filter} >
              <Col span={8}>
                <Input
                  name="welfareName"
                  label={t("welfare.label.name")}
                  placeholder={t("welfare.label.name")}
                  size="large"
                />
              </Col>

              <Col span={8}>
                <Select
                  name="subcategoryId"
                  label={t('welfare.label.type')}
                  placeholder={t('welfare.label.type')}
                  size="large"
                  options={welfareSubTypeOptions}
                />
              </Col>

              <Col span={8}>
                <Select
                  name="welfareTypeId"
                  label={t('welfare_list.Expense_type')}
                  placeholder={t('welfare_list.Expense_type')}
                  size="large"
                  options={welfareTypeOptions}

                />
              </Col>
              <Col span={8}>
                <Select
                  name="statusFlag"
                  label={t('translation.status')}
                  placeholder={t('translation.status')}
                  size="large"
                  options={modifiedStatus}
                />
              </Col>



            </Row>
            <Row gutter={[24, 16]} justify="end">
              <Space size={16} className={styles.filter}>
                <Button type="default" onClick={resetForm} size="large">
                  {t('payroll.reset')}
                </Button>
                <Button type="primary" htmlType="submit" size="large" style={{ backgroundColor: "var(--button-color)" }}>
                  {t("creatTamplete.Search").toUpperCase()}
                </Button>
              </Space>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

export default WelfareFilter;
